import React from 'react';
export default function PageNotFound() {
  return (
    <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] p-[16px]" style={{overflow:'auto'}}>
            

    {/* <img src='/cms/comingsoon.png' style={{width:'100%',objectFit:'contain'}}/> */}
</div>
  );
}

